import { doc, setDoc } from "firebase/firestore";
import getUserInsurances from "./getUserInsurances";
import SelectInsuranceToCancel from "./SelectProductToCancel";
import { db } from "../../../firebase";
import setInitialFormBDStructure from "../../../Components/CluppForms/setInitialFormBDStructure";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import Swal from "sweetalert2";

const landingId = "CF_SELECT_PRODUCT_TO_CANCEL";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  try {
    const fieldName = fieldsStructure[0].field.id;
    let prevForm = {};
    const prevOptionSelected = [];
    if (session?.sessionID) {
      prevForm = await getFormSession("cancelation-form", session.sessionID);
      if (prevForm) {
        const field = prevForm.items[0].answers[0];
        const fieldType = field.type;
        const answers = field[fieldType].value;
        prevOptionSelected.push(...answers);
      }
    }
    const products = await getUserInsurances(uid);

    return {
      userId: uid,
      [fieldName]: prevOptionSelected,
      products,
      prevForm,
      currentLanding: landingId,
    };
  } catch (err) {
    console.log("Error", err);
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
  setLoading,
}) => {
  const sessionID = localStorage.getItem("sessionID"); 
  if (sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${sessionID}`;
      const docRef = doc(db, path);
      const field = fieldsStructure[0];
      const fieldType = field.type;
      const fieldsStructureName = fieldsStructure[0].field.id;
      field[fieldType].value = state[fieldsStructureName];
      if (!field[fieldType].value.length > 0) {
        setLoading(false);
        return Swal.fire({
          icon: "warning",
          text: "Por favor, selecciona una de las opciones.",
          confirmButtonColor: "#00bbee",
        });
      }
      const isPartialCancellation =
        state.products.length > field[fieldType].value.length;
      const answers = [field];
      const dbStructure = setInitialFormBDStructure({
        session,
        landingId,
        metadata: {
          isPartialCancellation: isPartialCancellation || false,
        },
        answers,
        uid: state.userId,
      });

      await saveFormRecord(sessionID, dbStructure);
      await setDoc(docRef, dbStructure, { merge: true });
      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  } else{
    console.log("no Session");
    
  }
};

const content = ({ state, setState, fieldsStructure, setShowButtons }) => (
  <SelectInsuranceToCancel
    state={state}
    setState={setState}
    field={"CF_choose_product_ypij4"} // ID of the Field
    setShowButtons={setShowButtons}
  />
);

const nextPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`;
const prevPage = (props) => "";
const fieldsStructure = [
  {
    field: {
      id: "CF_choose_product_ypij4",
      type: "multiple_choice",
      ref: "CF_choose_product",
    },
    metadata: {},
    type: "choices",
    choices: {
      value: [],
    },
  },
];

const selectProductsProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default selectProductsProps;
